import { BlogSection } from '@/types/blog';

export const introSection: BlogSection = {
  id: 'intro',
  title: 'Einleitung: Steuerliche Klarheit für Krypto-Investoren',
  content: `
    <p>
      <strong>Wichtiger Hinweis:</strong> Dieser Artikel fasst die wichtigsten Punkte aus dem aktuellen <a href="https://www.bundesfinanzministerium.de/Content/DE/Downloads/BMF_Schreiben/Steuerarten/Einkommensteuer/2025-03-06-einzelfragen-kryptowerte.html" target="_blank" rel="noopener noreferrer">Schreiben des Bundesministeriums der Finanzen (BMF)</a> zusammen. Trotz größter Sorgfalt übernehme ich keine Haftung für die Richtigkeit und Vollständigkeit der hier bereitgestellten Informationen. Für verbindliche Auskünfte solltest du dich direkt an die Finanzbehörden oder deine Steuerberater*innen wenden.
    </p>

    <h2>Kryptowährungen als Wirtschaftsgüter – Was bedeutet das für dich?</h2>

    <p>
      Kryptowerte wie Bitcoin oder Ether werden steuerrechtlich als Wirtschaftsgüter eingestuft. Dies hat weitreichende Konsequenzen für deine persönliche Steuersituation: Wenn du Kryptowährungen kaufst, besitzt du ein steuerlich relevantes Gut – ähnlich wie bei anderen Vermögenswerten.
    </p>

    <p>
      Die zentrale Regel: Gewinne aus Verkäufen oder Tauschgeschäften innerhalb eines Jahres unterliegen der Einkommensteuer als <em>private Veräußerungsgeschäfte</em>. Eine wichtige Entlastung bietet die Freigrenze von 1.000 Euro – liegt dein Gesamtgewinn aus allen privaten Veräußerungsgeschäften (nicht nur Krypto) im Kalenderjahr darunter, bleiben diese steuerfrei.
    </p>
  `
};
